import React from 'react';

type CaseStatus =
  | 'APPLICATION_CREATED' |'APPLICATION_SUBMITTED' |'UNDER_REVIEW' |'MORE_INFO_REQUIRED' |'APPROVED' |'DECLINED' |'CANCELLED';

interface StatusBadgeProps {
  status: CaseStatus;
}

const STATUS_CONFIG: Record<CaseStatus, { label: string; classes: string }> = {
  APPLICATION_CREATED: { label: 'Created', classes: 'bg-slate-100 text-slate-600' },
  APPLICATION_SUBMITTED: { label: 'Submitted', classes: 'bg-blue-100 text-blue-700' },
  UNDER_REVIEW: { label: 'Under Review', classes: 'bg-amber-100 text-amber-700' },
  MORE_INFO_REQUIRED: { label: 'More Info Required', classes: 'bg-orange-100 text-orange-700' },
  APPROVED: { label: 'Approved', classes: 'bg-green-100 text-green-700' },
  DECLINED: { label: 'Declined', classes: 'bg-red-100 text-red-700' },
  CANCELLED: { label: 'Cancelled', classes: 'bg-gray-100 text-gray-500' },
};

const StatusBadge = ({ status }: StatusBadgeProps) => {
  const config = STATUS_CONFIG[status];
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-caption font-500 whitespace-nowrap ${config.classes}`}>
      {config.label}
    </span>
  );
};

export default StatusBadge;
export type { CaseStatus };